import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeToken } from "@core/index";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import AuthButton from "@modules/auth/components/AuthButton";
import AuthPaper from "@modules/auth/components/AuthPaper";
import { useAbility } from "@core/casl-provider";
import { getUserFromToken } from "@core/utils/auth";

const SsoAuthentication = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [failedState, SetFailedState] = useState(false);
  const { updateUser } = useAbility();

  useEffect(() => {
    // Get the value of the 'token' parameter from redirected URL
    const authCode = searchParams.get("token");

    if (authCode) {
      storeToken(authCode);
      const user = getUserFromToken();
      if (user) {
        updateUser(user);
        navigate("/dashboard");
      } else {
        SetFailedState(true);
      }
    } else {
      SetFailedState(true);
    }
  }, [navigate, searchParams, updateUser]);

  return (
    <Stack
      data-testid="sso-auth-container"
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        color: "white",
      }}
    >
      {!failedState ? (
        <>
          <CircularProgress size={60} />
          <Typography
            mt={2}
            sx={{
              fontSize: "18px",
            }}
          >
            Please wait...
          </Typography>
        </>
      ) : (
        // When login fails, show error message with button to go back to login page
        <Stack alignItems={"center"}>
          <AuthPaper>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "start",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  mb: 2,
                  color: "primary.main",
                  fontWeight: "400",
                  textAlign: "center",
                }}
              >
                Something went wrong during login. Please try again later.
              </Typography>

              {/* Continue with Google button */}
              <AuthButton width="60%" onClick={() => navigate("/login")}>
                Back to login
              </AuthButton>
            </Box>
          </AuthPaper>
        </Stack>
      )}
    </Stack>
  );
};

export default SsoAuthentication;
